import account from './zh-CN/account';
import commerce from './zh-CN/commerce';
import component from './zh-CN/component';
import dashboard from './zh-CN/dashboard';
import globalHeader from './zh-CN/globalHeader';
import membership from './zh-CN/membership';
import menu from './zh-CN/menu';
import pages from './zh-CN/pages';
import pwa from './zh-CN/pwa';
import referrals from './zh-CN/referrals';
import relationships from './zh-CN/relationships';
import settingDrawer from './zh-CN/settingDrawer';
import settings from './zh-CN/settings';
import system from './zh-CN/system';
import users from './zh-CN/users';

export default {
  'navBar.lang': '语言',
  'layout.user.link.help': '帮助',
  'layout.user.link.privacy': '隐私',
  'layout.user.link.terms': '条款',
  'app.preview.down.block': '下载此页面到本地项目',
  'app.welcome.link.fetch-blocks': '获取全部区块',
  'app.welcome.link.block-list': '基于 block 开发，快速构建标准页面',
  ...pages,
  ...globalHeader,
  ...menu,
  ...dashboard,
  ...users,
  ...membership,
  ...commerce,
  ...relationships,
  ...referrals,
  ...system,
  ...account,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
};
